import { useEffect, useState } from 'react';
import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { translateKey } from '../../../../../translate';
import { FormDivider, FormParagraph, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { NullableFormattedDate } from '../../../../elements/NullableFormattedDate';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';

export function Osasc2V2DiagnosticReportReadNsi(props: ICustomControlDiagnosticReportReadProps) {
    const [isFooterVisible, setIsFooterVisible] = useState(false);

    useEffect(() => {
        checkIsFooterVisible();
    }, [props.diagnosticReport.customControlData]);

    const fields = props.diagnosticReport.customControlData?.fields ?? {};

    return (
        <>
            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                {isFooterVisible && <FormDivider />}

                {fields.dateConsult && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.dateConsult')}</FormLabel>
                        <InputContainer>
                            <FormParagraph>
                                <NullableFormattedDate value={fields.dateConsult} />
                            </FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {fields.typeConsult && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.typeConsult')}</FormLabel>
                        <InputContainer>
                            <FormParagraph>{fields.typeConsult}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {fields.remarks && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.findings')}</FormLabel>
                        <InputContainer>
                            <FormParagraph>{fields.remarks}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {props.diagnosticReport?.remark && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.remarks')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{props.diagnosticReport.remark}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </CustomControlCollapseBody>

            {isFooterVisible && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('diagnosticReport.hideExaminationReport')}
                    labelMore={translateKey('diagnosticReport.showExaminationReport')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}
        </>
    );

    function checkIsFooterVisible() {
        if (fields.dateConsult || fields.typeConsult || fields.remarks || props.diagnosticReport.diagnosisRemarks) {
            setIsFooterVisible(true);
        }
    }
}
